export default __webpack_public_path__ + "ee92aaa61e2508c71f045e0dd095c6a7.woff2";